import { Component, OnInit } from '@angular/core';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
    constructor(
        public themeService: CustomizerSettingsService,
        private sessionService: SessionService
    ) {}

    ngOnInit() {
        console.log('Cerrando sesión y borrando cookies...');
        this.borrarTodasLasCookies();
    }

    borrarTodasLasCookies() {
        // Cierra la sesión en el backend (sesión única) y limpia cookies/localStorage
        this.sessionService.logout();
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    toggleCardBorderRadiusTheme() {
        this.themeService.toggleCardBorderRadiusTheme();
    }
}
